if (typeof ProductsSetBundle !== 'function') {

  class ProductsSetBundle extends HTMLElement {

    constructor() {
      super();

      this.lockedVariants = JSON.parse(this.dataset.lockedVariants || '{}');
      
      // Initialize after a brief delay to ensure DOM is ready
      setTimeout(() => {
        this.initSet();
        this.injectCustomInfo();
        this.checkSet();
      }, 150);

      this.querySelector('[data-js-add-set-to-cart]').addEventListener('click', e => {
        let items = [];
        Object.keys(this.set).map(key => {
          if (this.set[key] !== null) {
            items.push({
              id: this.set[key],
              quantity: 1
            });
          }
        });

        if (items.length > 0) {
          const submitButton = this.querySelector('[data-js-add-set-to-cart]');
          submitButton.classList.add('working');

          window.handleAddToCart(
            JSON.stringify({'items': items}), items.length,
            { 'Content-Type': 'application/json' },
            () => {
              submitButton.classList.remove('working');
            }
          );
        }
      });
    }

    formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '€{{amount}}';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision || 2;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    injectCustomInfo() {
      // Inject custom price and variant label inside each product card
      this.querySelectorAll('[data-product-item-index]').forEach(gridItem => {
        const productIndex = gridItem.dataset.productItemIndex;
        const variantId = gridItem.dataset.lockedVariant;
        const fallbackLabel = gridItem.dataset.variantLabel; // Fallback if dynamic fails
        const fallbackPrice = gridItem.dataset.variantPrice; // Fallback if dynamic fails
        
        if (!variantId || variantId === '') return;
        
        // Find the product-item element
        const productItem = gridItem.querySelector('.product-item');
        if (!productItem) return;
        
        // Hide the original variant selector and price
        const quickBuy = productItem.querySelector('.product-item__quick-buy');
        if (quickBuy) quickBuy.style.display = 'none';
        
        const priceElement = productItem.querySelector('.product-item__price');
        if (priceElement) priceElement.style.display = 'none';
        
        // Find the product-variants element to get data
        const productVariants = gridItem.querySelector('product-variants');
        
        let variantLabel = fallbackLabel;
        let variantPrice = fallbackPrice;
        let compareAtPrice = null;
        
        // Try to get dynamic data from productData
        if (productVariants && productVariants.productData && productVariants.productData.variants) {
          const variant = productVariants.productData.variants.find(v => String(v.id) === String(variantId));
          
          if (variant) {
            // Get variant title (e.g., "3 LOINS", "8-PACK")
            variantLabel = variant.title || fallbackLabel;
            
            // Get variant price
            if (variant.price) {
              const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '€{{amount}}';
              variantPrice = this.formatMoney(variant.price, moneyFormat);
              
              // Check for compare at price (sale price)
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                compareAtPrice = this.formatMoney(variant.compare_at_price, moneyFormat);
              }
            }
          }
        }
        
        // Find the best place to inject - after product text or at the end of product-item__text
        const productText = productItem.querySelector('.product-item__text');
        if (!productText) return;
        
        // Create custom info container
        const customInfo = document.createElement('div');
        customInfo.className = 'bundle-custom-info';
        
        // Add price if exists
        if (variantPrice && variantPrice !== '') {
          const priceDiv = document.createElement('div');
          priceDiv.className = 'bundle-custom-price';
          
          // If there's a sale, show both prices
          if (compareAtPrice) {
            priceDiv.innerHTML = `
              <span class="bundle-price-sale">${variantPrice}</span>
              <span class="bundle-price-compare">${compareAtPrice}</span>
            `;
          } else {
            priceDiv.textContent = variantPrice;
          }
          
          customInfo.appendChild(priceDiv);
        }
        
        // Add variant label if exists
        if (variantLabel && variantLabel !== '') {
          const labelDiv = document.createElement('div');
          labelDiv.className = 'bundle-custom-variant';
          labelDiv.textContent = variantLabel;
          customInfo.appendChild(labelDiv);
        }
        
        // Insert into product text area
        productText.appendChild(customInfo);
      });
    }

    initProducts() {
      this.querySelectorAll('product-variants').forEach((elm, i) => {
        if (!elm.hasAttribute('data-init')) {
          const setid = elm.closest('.product-item').dataset.setIndex = i;
          
          // Check if this product has a locked variant
          const productIndex = i + 1; // 1-based for settings
          const lockedVariantId = this.lockedVariants[String(productIndex)];
          
          if (lockedVariantId && lockedVariantId !== '') {
            // This is a locked variant - set it directly
            this.set[setid] = lockedVariantId;
            elm.closest('[data-js-product-item]').classList.add('selected');
            
            // Set the hidden input value
            const hiddenInput = elm.parentNode.querySelector('input[name="id"]');
            if (hiddenInput) {
              hiddenInput.value = lockedVariantId;
            }
            
          } else {
            // Original theme behavior for non-locked variants
            if (!elm.hasAttribute('data-has-variants') && !elm.hasAttribute('data-unavailable')) {
              this.set[setid] = elm.parentNode.querySelector('input[name="id"]').value;
            } else {
              this.set[setid] = null;
              if (elm.dataset.variants == '1') {
                if (elm.querySelector('input[type="radio"]:checked, option:not([data-disabled]):checked') !== null) {
                  this.set[setid] = elm.parentNode.querySelector('input[name="id"]').value;
                  elm.closest('[data-js-product-item]').classList.add('selected');
                  const addToCartBtn = elm.closest('[data-js-product-item]').querySelector('.add-to-cart');
                  if (addToCartBtn) {
                    addToCartBtn.classList.remove('disabled');
                  }
                  this.checkSet();
                }
              }
              elm.addEventListener('VARIANT_CHANGE', e => {
                let variant = e.target.currentVariant;
                if (variant && variant.available) {
                  this.set[setid] = elm.parentNode.querySelector('input[name="id"]').value;
                  elm.closest('[data-js-product-item]').classList.add('selected');
                } else {
                  this.set[setid] = null;
                }
                this.checkSet();
              });
            }
          }

          elm.setAttribute('data-init', '');

          elm.closest('.product-item').addEventListener('reload', e => {
            this.initProducts();
            this.checkSet();
          });
        }
      });
    }

    initSet() {
      this.set = {};
      this.initProducts();
    }

    checkSet() {
      let setFull = true;
      Object.keys(this.set).map(key => {
        if (this.set[key] === null) {
          setFull = false;
        }
      });

      if (setFull && this.classList.contains('products-set--empty')) {
        this.classList.remove('products-set--empty');
        const buttonText = this.querySelector('[data-js-add-set-to-cart-text]');
        if (buttonText) {
          buttonText.textContent = this.dataset.buttonText || 'Add bundle to cart';
        }
      } else if (!setFull && !this.classList.contains('products-set--empty')) {
        this.classList.add('products-set--empty');
      }

      return setFull;
    }
  }

  if (typeof customElements.get('products-set-bundle') == 'undefined') {
    customElements.define('products-set-bundle', ProductsSetBundle);
  }
}